// Keys are the path from the root rather than the bare collection id, because
// the same collection can appear twice in a tree. A collection has one parent,
// but collection search lists every match at the top level, and expanding one
// match loads its children, which can include another match. Duplicate keys
// corrupt the tree's React Aria collection and crash the virtualizer. Web trees
// build the same format with `getTreeNodePathKey`.
const TREE_KEY_SEPARATOR = '/';

export function toTreeKey(parentKey: string, collectionId: string): string {
  return `${parentKey}${TREE_KEY_SEPARATOR}${collectionId}`;
}

/** The collection a tree key points at, i.e. the last segment of its path. */
export function collectionIdFromTreeKey(key: string): string {
  const segments = key.split(TREE_KEY_SEPARATOR);
  return segments[segments.length - 1];
}
